import { route } from "preact-router";
import { fetchGraphql } from "./graphqlClient";
import { removeTokens, setAccessToken, setRefreshToken } from "./tokens";
import { loginQuery, selfuserQuery } from "../../graphql/queries";
import { LoginMutation, LoginMutationVariables, SelfUserQuery, SelfUserQueryVariables } from "../../graphql/types";

export async function login(email: string, password: string): Promise<boolean> {
    try {
        const tokenResult = await fetchGraphql<LoginMutation, LoginMutationVariables>("Login", loginQuery, { email, password }, false);
        if (!tokenResult?.data?.token)
            return false;

        setAccessToken(tokenResult.data.token.accessToken);

        const userResult = await fetchGraphql<SelfUserQuery, SelfUserQueryVariables>("SelfUser", selfuserQuery, {});

        if (tokenResult.data.token.refreshToken) {
            setRefreshToken(tokenResult.data.token.refreshToken);
        }

        updateLoginState();
        return true;
    }
    catch {
    }
    return false;
}

export function logout() {
    removeTokens();
    updateLoginState();
    route("/");
}

const listeners: Array<(loggedIn: boolean) => void> = [];

function updateLoginState() {
    window.dispatchEvent(new Event("storage"));
}